module.exports = __webpack_public_path__ + "assets/img/txt-message.ee3aca17.png";